<script lang="ts" context="module">
  export interface ContainerProps {
    layers: Layer[];
    addClasses?: string;
  }
  export interface Layer {
    backgroundCSS?: string;
    backgroundVideo?: {
      videoUrl: string;
      imageUrl: string;
    };
    backgroundImage?: {
      url: string;
      classes?: string;
    };
    fullscreenBackgroundImage?: {
      asset: StatamicAsset;
      pictureClasses?: string;
      pictureClasses?: string;
    };
    halfscreenBackgroundImage?: {
      asset: StatamicAsset;
      pictureClasses?: string;
      pictureClasses?: string;
    };
    image?: {
      url: string;
      size?: "small" | "medium" | "large";
      position?:
        | "bottom"
        | "center"
        | "left"
        | "left-bottom"
        | "left-top"
        | "right"
        | "right-bottom"
        | "right-top"
        | "top";
      wrapperClasses?: string;
      imageClasses?: string;
    };
  }
  const sizeClasses = {
    small: "max-w-screen-sm",
    medium: "max-w-screen-md",
    large: "max-w-screen-lg",
  };
  const positionClasses = {
    bottom: "justify-end items-center",
    center: "justify-center items-center",
    left: "justify-start items-center",
    "left-bottom": "justify-start items-end",
    "left-top": "justify-start items-start",
    right: "justify-end items-center",
    "right-bottom": "justify-end items-end",
    "right-top": "justify-end items-start",
    top: "justify-start items-center",
  };
</script>

<script lang="ts">
  import { twMerge } from "tailwind-merge";
  import FullscreenBackgroundImage from "@components/layout/FullscreenBackgroundImage.svelte";
  import HalfscreenBackgroundImage from "@components/layout/HalfscreenBackgroundImage.svelte";

  export let addClasses: string = "";
  export let layers: Layer[] = [];
  export let video: HTMLVideoElement | null = null;
</script>

<section class={twMerge("w-full relative ", addClasses)} {...$$restProps}>
  {#each layers as layer}
    {#if layer.halfscreenBackgroundImage && layer.halfscreenBackgroundImage.asset}
      <HalfscreenBackgroundImage
        loading="lazy"
        class={`absolute ${layer.halfscreenBackgroundImage.classes ? layer.halfscreenBackgroundImage.classes : "object-cover w-full h-full"}`}
        image={layer.halfscreenBackgroundImage.asset}
      />
    {/if}
    {#if layer.fullscreenBackgroundImage}
      <FullscreenBackgroundImage
        loading="lazy"
        class={`absolute ${layer.fullscreenBackgroundImage.classes ? layer.fullscreenBackgroundImage.classes : "object-cover w-full h-full"}`}
        image={layer.fullscreenBackgroundImage.asset}
      />
    {/if}
    {#if layer.backgroundImage}
      <img
        loading="lazy"
        class={`absolute ${layer.backgroundImage.classes ? layer.backgroundImage.classes : "object-cover w-full h-full"}`}
        alt=""
        src={layer.backgroundImage.url}
      />
    {/if}
    {#if layer.image}
      <div
        class={`absolute w-full h-full flex ${positionClasses[layer.image.position ?? "center"]} `}
      >
        <img
          loading="lazy"
          class={`${layer.image.imageClasses ? layer.image.imageClasses : "object-contain  w-full h-full "} ${sizeClasses[layer.image.size] ?? ""}`}
          alt=""
          src={layer.image.url}
        />
      </div>
    {/if}
    {#if layer.backgroundVideo}
      <video
        bind:this={video}
        class="vimeo-iframe md:block"
        width="250"
        playsinline
        muted
        loop
        poster={layer.backgroundVideo.imageUrl}
      >
        <source src={layer.backgroundVideo.videoUrl} type="video/mp4" />
      </video>
      <!-- <img
        class="vimeo-iframe block md:hidden"
        src={layer.backgroundVideo.imageUrl}
        alt=""
      /> -->
    {/if}
    {#if layer.backgroundCSS}
      <div
        style={layer.backgroundCSS}
        class="object-cover absolute w-full h-full z-10"
      ></div>
    {/if}
  {/each}
  <slot />
</section>
